import {
  faArrowLeftLong,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faChartSimple,
  faCheck,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleInfo,
  faCirclePlus,
  faCircleNotch,
  faClock,
  faDownload,
  faEllipsisH,
  faHandshake,
  faHospitalUser,
  faList,
  faMapMarkerAlt,
  faMinus,
  faPlus,
  faQuestionCircle,
  faRedo,
  faRoute,
  faSpinner,
  faSquare,
  faStopwatch,
  faTh,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUser,
  faUsers,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';

export const icons = [
  faArrowLeftLong,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faChartSimple,
  faCheck,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleInfo,
  faCirclePlus,
  faCircleNotch,
  faClock,
  faDownload,
  faEllipsisH,
  faHandshake,
  faHospitalUser,
  faList,
  faMapMarkerAlt,
  faMinus,
  faPlus,
  faQuestionCircle,
  faRedo,
  faRoute,
  faSpinner,
  faSquare,
  faStopwatch,
  faTh,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUser,
  faUsers,
  faUserTie
];
